import { create } from "zustand";

export type LockedField = {
  lockedByUserId?: string;
  lockedByUserName?: string;
  lastTouchedAt?: Date;
};

export type LockedFields = {
  [key: string]: LockedField;
};

type DraftStore = {
  lockedFields: LockedFields;
  focusFieldId?: string;
  setFocusFieldId: (id: string) => void;
  setLockedFields: (fields: LockedFields) => void;
  clearFocusFieldId: () => void;
};

export const useDraftStore = create<DraftStore>((set) => ({
  lockedFields: {},
  focusFieldId: undefined,

  setLockedFields: (fields: LockedFields): void => {
    set({ lockedFields: fields });
  },

  setFocusFieldId: (fieldId: string): void => {
    set({ focusFieldId: fieldId });
  },

  clearFocusFieldId: (): void => {
    set({ focusFieldId: undefined });
  },
}));
